import React, { useRef } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { storeAssigned, _logoutFunction } from '../../services/Methods/normalMethods'
import logo from '../../assets/headerlogo.png';
import discover from '../../assets/discover.png';
import user from '../../assets/user.png';
import email from '../../assets/emailicon.png';
import cross from "../../assets/cross.png"
import localStorageCall from '../../services/Methods/localstorage.hook';
import { MyAccoutnAPI } from '../../services/Redux/Reducer/LoginSlice';
import _ from 'lodash';
import classNames from 'classnames';
import ReactCountryFlag from 'react-country-flag';
import CountryFlagDropdown from '../../Layout/Header/CountryFlagDropdown';


const NewHeader = (props) => {

    const {
        COMMON_TEXTS, ROUTING_TEXT, location, subTotal, dispatch,
        isUserLogin, countyObjects, userData,
        showCountries, setShowCountries, selectedStore, setSelectedStore
    } = props;

    const HEADER_LINKS = [
        { link: `/${storeAssigned()}/${ROUTING_TEXT?.Shop_routingName}`, text: COMMON_TEXTS?.shop_text },
    ];
    const usePathname = () => {
        const location = useLocation();
        return location.pathname;
    };
    const path = usePathname();
    const navigate = useNavigate();
    const wrapperRef = useRef(null);

    function handleBackOffice() {
        if (isUserLogin) {
            dispatch(MyAccoutnAPI())
        }
        else {
            navigate(`/${storeAssigned()}/${ROUTING_TEXT?.login_routingName}`)
        }
    };
    return (
        <>
            <header className='bg-[#F6F7FB] py-[20px]'>
                <div className="top-header-wrap bg-[#F6F7FB]">
                    <div className="container max-w-[1760px] mx-auto px-[20px]">
                        <div className="top-header flex flex-wrap items-center justify-between">
                            <div className="support-header flex flex-wrap items-center" >

                            </div>
                            <div className='flex items-center'>
                                <div>
                                    <p className='text-[#000] opacity-60 text-[14px] leading-[21px] font-normal'>
                                        {!(isUserLogin) ?
                                            `${localStorageCall().getItem('refferal_link')?.name ? COMMON_TEXTS?.reffer_by + ': ' + localStorageCall().getItem('refferal_link')?.name : ''}`
                                            :
                                            COMMON_TEXTS?.welcomeText + ', ' + (userData?.fullName || '')
                                        }
                                    </p>
                                </div>
                                {/* <div className='relative' ref={wrapperRef}>
                            <button className="topbar-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false" onClick={() => {
                                setShowCountries(!showCountries);
                            }}>
                                <ReactCountryFlag countryCode={selectedStore?.defaultCode || 'US'} style={{
                                    fontSize: '1em', marginRight: '2px', lineHeight: '2em', marginLeft: '1rem'
                                }} />
                            </button>
                            <CountryFlagDropdown {...{ selectedStore, setSelectedStore, countyObjects, showCountries, setShowCountries }} />
                        </div> */}
                            </div>

                        </div>
                    </div>
                </div>
                <div className='container max-w-[1760px] mx-auto px-[15px]'>
                    <div className={`wrapper flex justify-between items-center md:gap-[10px] gap-[4px] ${isUserLogin ? 'flex-wrap' : ''}`}>
                        <div className={`logo_main max-w-[max-content] ${isUserLogin ? 'max-w-[max-content] w-auto sm:max-w-full ' : ''}`}>

                            <Link to={`/${storeAssigned()}`} reloadDocument className="">
                                <img className='xl:max-w-[311px] lg:max-w-[250px] md:max-w-[200px] max-w-[100px] block h-full object-contain' src={logo} alt="logo" />
                            </Link>
                        </div>
                        {/* <div className="center-div xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center  uppercase"><span><img className='xl:w-[22px] lg:w-[18px] w-[16px]' src={discover} alt="" /></span>Discover</div> */}
                        <div
                            className="center-div xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center  uppercase">
                            {isUserLogin && userData?.customerType === 1 &&
                                <a className='xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex xl:gap-[26px] md:gap-[10px] gap-[4px] items-center uppercase mr-[17px]' href={`/${storeAssigned()}/${ROUTING_TEXT?.IBOSignup_routingName}`}>Become a Wholesale affiliate</a>}

                            {isUserLogin && userData?.customerType !== 4 &&
                                // <div
                                //     className="center-div xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center  uppercase">

                                <ul>
                                    {_.map(HEADER_LINKS, (row, index) => (
                                        <li
                                            key={index + 1}
                                            className={classNames('', { "mr-[0px] group-[.open-menu]:mr-0 group-[.open-menu]:mb-[5px]": (HEADER_LINKS?.length - 0 !== index) })}
                                            data-te-nav-item-ref>
                                            <Link
                                                reloadDocument
                                                className={`xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center uppercase cursor-pointer`}
                                                to={row?.link}>
                                                {row?.text}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            }
                            <nav>
                                <ul className='flex items-center xl:gap-[26px] md:gap-[10px] gap-[4px] '>
                                    {/* <li>
                                    <a className='xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center uppercase' href="#"><span><img className='xl:w-[22px] lg:w-[18px] w-[16px]' src={email} alt="" /></span>Support</a>
                                </li> */}
                                    {/* <li>
                                    <a className='xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center uppercase' href={`/${storeAssigned()}/login`}><span><img className='xl:w-[22px] lg:w-[18px] w-[16px]' src={user} alt="" /></span>Login</a>
                                </li> */}
                                    <div className={`relative ${isUserLogin ? 'responsive_country_dropdown' : 'country_dropdown'}`} ref={wrapperRef}>
                                        <button className="topbar-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false" onClick={() => {
                                            setShowCountries(!showCountries);
                                        }}>
                                            <ReactCountryFlag countryCode={selectedStore?.defaultCode || 'US'} style={{
                                                fontSize: '1em', marginRight: '2px', lineHeight: '2em', marginLeft: '1rem'
                                            }} />
                                        </button>
                                        <CountryFlagDropdown {...{ selectedStore, setSelectedStore, countyObjects, showCountries, setShowCountries }} />
                                    </div>
                                    {/* <div id="weglot_here"></div> */}
                                    {isUserLogin &&

                                        <li onClick={() => handleBackOffice()} className="mr-[0px] group-[.open-menu]:mr-0 group-[.open-menu]:mb-[5px]" data-te-nav-item-ref>
                                            <Link
                                                className={`xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center uppercase cursor-pointer`}
                                                to='#'>
                                                Back Office
                                            </Link>
                                            {/* <span>Back Office</span> */}
                                        </li>
                                    }


                                    {!(isUserLogin)
                                        ?
                                        <li>
                                            <a className='xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center uppercase' href={`/${storeAssigned()}/login`}><span><img className='xl:w-[22px] lg:w-[18px] w-[16px]' src={user} alt="" /></span>Login</a>
                                        </li>
                                        :
                                        <a onClick={() => _logoutFunction('redirect', userData)} className='xl:text-[19px] lg:text-[18px] md:text-[14px] text-[11px] leading-[1] text-[#000] flex gap-[5px] items-center uppercase cursor-pointer'>
                                            <span><img className='xl:w-[22px] lg:w-[18px] w-[16px]' src={user} alt="" /></span>
                                            Logout
                                        </a>
                                    }

                                    {
                                        !path.includes("/") &&

                                        <li onClick={() => navigate(`/${storeAssigned()}/`)}>
                                            <img className='xl:max-w-[35px] lg:max-w-[30px] md:max-w-[25px] max-w-[16px] block h-full w-full object-contain' src={cross} alt="logo" />
                                        </li>
                                    }
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default NewHeader